function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-742.606-39.2-960.73,338.184A3.106,3.106,0,0,0-958,342.839l85.21-.208a3.166,3.166,0,0,0,2.711-1.576l127.9-221.262a3.14,3.14,0,0,1,5.422-.015L-607.234,341.2a3.093,3.093,0,0,0,2.711,1.547l85.24-.178a3.116,3.116,0,0,0,2.711-4.67L-737.184-39.217A3.145,3.145,0,0,0-742.606-39.2Z",
  transform: "translate(961.15 40.76)",
  fill: "fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-915.226-13l-42.388,73.856a3.143,3.143,0,0,0,2.727,4.7l235.213-.614a3.149,3.149,0,0,0,2.71-4.718l-42.791-73.646a3.087,3.087,0,0,0-2.711-1.558l-150.048.4A3.18,3.18,0,0,0-915.226-13Z",
  transform: "translate(1004.734 398.439)",
  fill: "fill"
}));

function SvgBgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 445,
    height: 464,
    viewBox: "0 0 445 464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome);
export default __webpack_public_path__ + "static/media/bg_home.9c0ad000.svg";
export { ForwardRef as ReactComponent };